import { get } from 'lodash/fp';

const useFilterArray = () => {
  const filterArray = (array, key, value) => array.filter((obj) => get(key, obj) === value);

  return filterArray;
};

export default useFilterArray;
